import { FC, ReactNode } from "react";
import classNames from "classnames";
import { AccountingIcon, ChevronRightSmallIcon } from "@icons";
import styles from "../AddClientDrawerSteps.module.scss";

interface Props {
    isExpanded: boolean;
    onToggle: () => void;
    children: ReactNode;
}

export const MigrationSetupTile: FC<Props> = ({
    isExpanded,
    onToggle,
    children,
}) => (
    <div className={styles.migrationOption}>
        <div
            className={classNames(styles.kickOption, styles.kickOptionBare)}
            onClick={onToggle}
            role="button"
            tabIndex={0}
            aria-expanded={isExpanded}
        >
            <div className={styles.kickOptionContent}>
                <div className={styles.kickOptionIcon}>
                    <AccountingIcon />
                </div>
                <div className={styles.kickOptionTexts}>
                    <div className={styles.kickOptionTitle}>
                        Migrate from other accounting software
                    </div>
                    <div className={styles.kickOptionDescription}>
                        QuickBooks, Xero, and more
                    </div>
                </div>
            </div>
            <ChevronRightSmallIcon
                aria-hidden
                className={classNames(styles.kickOptionChevron, {
                    [styles.kickOptionChevronExpanded]: isExpanded,
                })}
            />
        </div>
        <div
            className={classNames(styles.migrationOptionBody, {
                [styles.migrationOptionBodyExpanded]: isExpanded,
            })}
            inert={!isExpanded}
        >
            <div className={styles.migrationOptionBodyInner}>{children}</div>
        </div>
    </div>
);
